import { onMounted, onUnmounted, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import type { RouteLocationNormalized } from 'vue-router'

/**
 * Reset the keyboard focus to the body tag on page changes.
 * Works only in the browser (safe for SSR).
 */
export const useRouterFocusReset = (): void => {
  const router = useRouter()
  let removeAfterEach: (() => void) | null = null

  onMounted(() => {
    removeAfterEach = router.afterEach(
      (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
        if (from.path !== to.path) {
          void nextTick(() => {
            if (typeof document !== 'undefined' && document.body) {
              document.body.tabIndex = 0
              document.body.focus()
              document.body.tabIndex = -1
            }
          })
        }
      }
    )
  })

  onUnmounted(() => {
    if (removeAfterEach) {
      removeAfterEach()
      removeAfterEach = null
    }
  })
}
